<template>
  <editForm
    :key="mappedCloseOption + '|' + formsid"
    :formsesid="formsid"
    :requiredsubmit="false"
    :closeoption="mappedCloseOption"
    :isfieldvalidate="showpopup"
    :showsignlist="isshowsignlist"
    :isPatientVisit="isPatientVisit"
  />
</template>

<script src="./editform.js"></script>